import { render, staticRenderFns } from "./CelestialQuoteHistoryDisplay.vue?vue&type=template&id=198b74ab&scoped=true&"
import script from "./CelestialQuoteHistoryDisplay.vue?vue&type=script&lang=js&"
export * from "./CelestialQuoteHistoryDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CelestialQuoteHistoryDisplay.vue?vue&type=style&index=0&id=198b74ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198b74ab",
  null
  
)

export default component.exports